import { render, staticRenderFns } from "./kv-tabs.vue?vue&type=template&id=4f0ad9f2&scoped=true"
import script from "./kv-tabs.vue?vue&type=script&lang=js"
export * from "./kv-tabs.vue?vue&type=script&lang=js"
import style0 from "./kv-tabs.vue?vue&type=style&index=0&id=4f0ad9f2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0ad9f2",
  null
  
)

export default component.exports